




































































import store from '@/store'
import ApiClient from '@/js/api.js'
import Pankuzu from '@/views/molecules/Pankuzu.vue'
import Title from '@/views/atoms/Title.vue'
import NormalButton from '@/views/atoms/NormalButton.vue'
import YellowButton from '@/views/atoms/YellowButton.vue'
import BackButton from '@/views/atoms/BackButton.vue'
import DeleteButton from '@/views/atoms/DeleteButton.vue'
import ManageSubTitle from '@/views/atoms/ManageSubTitle.vue'
import ManageRow from '@/views/organisms/ManageRow.vue'
import ManageBase from '@/views/organisms/ManageBase.vue'
import ManageTemplate from '@/views/templates/ManageTemplate.vue'
import ConfirmPopup from '@/views/molecules/ConfirmPopup.vue'

export default
  name: 'MyPage'

  components: {
    Pankuzu
    Title
    NormalButton
    YellowButton
    BackButton
    DeleteButton
    ManageSubTitle
    ManageRow
    ManageBase
    ManageTemplate
    ConfirmPopup
  }

  data: () ->
    memberData: {}
    isShowDeletePopup: false
    isShowTaikaiPopup: false
    deleteID: 0
    sendPlaceCount: 0

  created: () ->
    store.dispatch('initPostParam')
    @$emit('set_color', true)
    @_getDetail()

  methods: {
    go_append_send: (e) ->
      store.dispatch('setBackURL', '/mypage')
      @$router.push '/mypage/add_sender'
    go_edit_user: (e) ->
      store.dispatch('setBackURL', '/mypage')
      @$router.push '/user/edit'
    go_password: (e) ->
      @$router.push '/user/password'
    go_edit_sender: (id) ->
      store.dispatch('setBackURL', '/mypage')
      @$router.push '/mypage/edit_sender?id=' + id
    go_point: (e) ->
      @$router.push '/mypage/point_history'
    go_history: (e) ->
      @$router.push '/mypage/order_history'
    go_taikai: (e) ->
      @isShowTaikaiPopup = true
    go_logout: (e) ->
      api = new ApiClient()
      data = await api.get('/member/login/logout')
      store.dispatch('setLoginStatus', false)
      @$router.push '/'
    confirm_delete: (id) ->
      @deleteID = id
      @isShowDeletePopup = true
    execute_taikai: (e) ->
      api = new ApiClient()
      await api.get('/member/user/delete')
      data = await api.get('/member/login/logout')
      store.dispatch('setLoginStatus', false)
      @$router.push '/'
    execute_taikai_close: (e) ->
      @isShowTaikaiPopup = false
    execute_delete: () ->
      store.dispatch('setPostParam', {label: 'id', value: @deleteID})
      api = new ApiClient()
      data = await api.post('/member/sendplace/delete')
      @_getDetail()
    execute_close: () ->
      @isShowDeletePopup = false
    _getDetail: () ->
      api = new ApiClient()
      data = await api.get('/member/user/detail')
      this.memberData = data.detail
      @sendPlaceCount = data.detail.member_sendplaces.length
  }
